import { IKeys } from "../../Interfaces";

const lang: IKeys = {
    fr: "فرنسية",
    en: "إنجليزية",
    ar: "عربية",
    connexion : "تسجيل ",
     connexionTitle : " تسجيل الدخول",
    inscriptionTitle : "إنشاء حساب",
    forgetPass :"هل نسيت كلمة السر؟",
    register : "إنشاء ",
    haveAccount : "هل لديك حساب بالفعل؟",
    identifiant : "معرف",
    mdp : "كلمة السر",
    rememberMe :"تذكرنى",
    firstName : "الإسم",
    lastName : "اللقب",
    confirmPassword : "تثبيت كلمة السر",
    acceptCondition : "أوافق على شروط الاستخدام",
    validationMessage: "نعم",
    emptyMessage : "اجباري",
    invalidMailMessage : "إنه ليس بريدًا إلكترونيًا",
    forgetPassBtn : "",
    resetPassTitle : "",
    resetPassBtn : "",
    reliabilityMessage : "",
    ForgetPassTitle : " ",


}
export default lang;